var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKrolfbane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.59 15.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #071f39;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cirkel"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0,
    width: 15.59,
    height: 15.59,
    rx: 7.8,
    ry: 7.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.44,9.36c-.2,0-.36.16-.36.36s.16.36.36.36.36-.16.36-.36-.16-.36-.36-.36Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.64,10.1c-.55,0-1-.16-1-.37v.17c0,.2.45.37,1,.37s1-.16,1-.37v-.17c0,.2-.45.37-1,.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.64,9.91c.48,0,.84-.13.97-.28.02-.02.03-.06.03-.09,0-.19-.41-.34-.92-.36v-2.52c.34-.04.61-.32.61-.67,0-.38-.31-.69-.69-.69s-.69.31-.69.69c0,.35.27.63.61.67v2.52c-.51.02-.92.17-.92.36,0,.03.02.08.04.11.07.1.48.26.96.26Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5.29,4.05c.55,0,.99-.44.99-.99s-.44-.99-.99-.99-.99.44-.99.99.44.99.99.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M9.05,12.54l-.02-.04c-.06-.17-.11-.31-.41-.19l-.34.12-1.44-4.02c.4-.44,1.19-1.56,1.15-1.92-.06-.53-.42-1.01-.69-1.43-.47-.71-1.17-.65-1.68-.65h-.64c-.62,0-1.4.54-1.36,1.16l.02,2.62.08,4.58c0,.25.2.45.45.45s.45-.2.45-.45l.46-3.98h.14l.46,3.98h0c0,.25.2.45.45.45s.45-.2.45-.45c0-.02,0-.04-.01-.06l.11-3.9,1.33,3.7.13-.05-.47.17c-.26.1-.25.24-.19.41l.02.04c.06.17.14.29.41.19l.94-.34c.29-.11.25-.24.19-.41ZM7.13,6.61l-.47.69v-1.46l.47.77Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKrolfbane);
export default __webpack_public_path__ + "static/media/KROLFBANE.12f0209c716d22cec632399b0d2b08ee.svg";
export { ForwardRef as ReactComponent };